var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 243.24 117.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-2 {\n        fill: #9e4623;\n        stroke: #75341a;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3px;\n      }\n\n      .cls-3 {\n        fill: #820e0e;\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 125.38,
    cy: 34.93,
    fx: 125.38,
    fy: 34.93,
    r: 21.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#820e0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9e4623"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.09,34.1c-.51-.31-1.63-.79-2.26-2.08-.22-.45-.35-.94-.41-1.44-.38-9.08,18.86-10.92,25.35-13.76,5.76-2.04,11.37-5.07,17.4-6.31,3.7-.79,7.45-1.16,11.19-1.72,6.53-.96,12.95-2.52,19.5-3.33,21.53-2.46,42.58,6.04,64.19,4.92,11.01.04,21.75-2.95,32.21-6.07,10.25-3.03,21.07-2.81,31.65-2.82,3.67-.06,2.32,1.68,2.22,5.1.08,5.57,2.97,11.12,4.55,16.1,1.66,5.11,2.43,10.6,2.78,15.98.33,5.11.51,10.39-.6,15.75-1.67,8.7-12.07,5.96-20.27,5.22-7.71-.89-16.76-.74-23.08,4.5-7.3,5.94-13.2,13.23-21.26,18.37-7.88,5.14-16.64,8.36-25.19,12.15-10.17,4.66-20.21,9.49-30.57,13.73-8.46,3.79-17.69,4.62-26.67,6.37-2.57.53-5.38,1.89-7.58.3-3.11-2.49-2.01-9.38-.34-13.33,7.53-14.95,35.24-16.03,46.93-26.43,1.92-1.95,1.35-4.26-.81-5.8-3.75-2.71-8.85-1.91-13.15-2.39-7.91-.75-15.9-1.9-23.8-2.2-14.52-.63-29.5-.22-42.85,6.04-5.43,2.47-10.65,4.94-15.65,8.31-4.91,3.19-10.54,7.62-16.53,7.12-2.95-.33-6.02-1.53-8.13-3.75-5.66-5.9,12.44-13.7,4.15-11.27-4.27,1.2-8.76,2.05-11.77.26-2.39-1.36-3.62-4.55-2.27-7.01,1.93-4.05,7.33-6.83,10.54-9.33.34-.34.02-.37-.81-.24-1.07.17-2.77.48-3.84-.01-6.71-4.36,7.98-11.63,11.58-13.97,3.71-2.4,9.5-5.82,13.59-6.95v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.23,68.7c18.6-13.58,37.04-23.9,59.93-28.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.17,56.18c21.45-14.87,39.76-28.01,66.5-30.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.33,34.22c7.12-4.41,14.35-8.82,22.15-11.86,7.82-3.16,16.13-4.59,24.43-5.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.29,27.6c-6.07-7.99-18.06-13.18-27.7-9.57-.78-.24-1.67-.28-2.65-.06-9.4,2.17-21.55,13.86-13.38,23.66,3.43,4.12,9.25,5.92,14.07,7.82,5.72,2.26,12.16,4.32,18.37,3.28,10.4-1.74,18.13-16.13,11.28-25.14ZM138.72,39.23c-1.42,3.15-4,3.96-7.31,3.75-5.58-.36-11.77-3.14-16.73-5.56-2.82-1.38-4.63-2.42-2.31-5.53,1.49-2,3.5-3.15,5.78-3.87,1.23.51,2.69.53,4.2-.3,5.11-2.82,11.34.9,15.26,4.25,2.44,2.09,2.39,4.45,1.12,7.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M139.71,46.16c1.93,0,1.93-3,0-3s-1.93,3,0,3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M133.2,49.87c1.93,0,1.93-3,0-3s-1.93,3,0,3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M122.99,48.59c1.93,0,1.93-3,0-3s-1.93,3,0,3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M113.8,45.02c1.93,0,1.93-3,0-3s-1.93,3,0,3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M106.39,39.53c1.93,0,1.93-3,0-3s-1.93,3,0,3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M108.82,31.99c1.93,0,1.93-3,0-3s-1.93,3,0,3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M117.37,24.84c1.93,0,1.93-3,0-3s-1.93,3,0,3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M127.84,24.33c1.93,0,1.93-3,0-3s-1.93,3,0,3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M136.65,26.76c1.93,0,1.93-3,0-3s-1.93,3,0,3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M142.65,30.97c1.93,0,1.93-3,0-3s-1.93,3,0,3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M146.22,38.25c1.93,0,1.93-3,0-3s-1.93,3,0,3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M136.16,53.13l-.45-1.66c-.31-1.15-.6-2.32-1.18-3.37-.31-.56-1.18-.06-.86.5.05.1.09.2.14.3-.54-.28-1.01.55-.47.87.78.47,1.06,1.42,1.12,2.28.04.56.01,1.12,0,1.68,0,.46-.02.95.22,1.36.48.84,1.91.7,1.87-.4-.02-.52-.25-1.07-.39-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M124.84,52.3c-.24-.75-.85-1.27-1.19-1.96-.44-.89.44-1.88-.19-2.75-.25-.35-.77-.31-.91.12-.02.04-.02.09-.03.13-.27.04-.51.26-.4.6.3.94.21,1.92.27,2.89.03.49.08.99.24,1.46.14.43.38.99.8,1.22.51.28,1.08,0,1.34-.48.2-.37.21-.84.09-1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M115.46,50.26c-.3-.5-.43-1.08-.51-1.65-.2-1.35-.17-2.73-.8-3.98-.08-.15-.21-.22-.35-.24,0-.02,0-.04-.02-.05-.24-.59-1.2-.33-.96.27.53,1.33.57,2.75.62,4.16.04,1.19-.03,2.7.71,3.72.34.47.95.9,1.55.67.51-.2.75-.77.69-1.29-.07-.65-.6-1.07-.92-1.61Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M107.52,38.86s0-.02,0-.03c0,.01,0,.01,0,.02,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M108.38,40.62c-.09-.39-.32-.73-.53-1.06-.05-.09-.11-.17-.16-.26-.03-.05-.05-.09-.08-.14-.01-.02-.02-.04-.03-.06,0,0,0,0,0,0-.04-.06-.05-.16-.07-.23,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0-.04,0-.03,0,0,0-.01,0-.03,0-.03,0-.04.02-.22,0-.07.04-.26-.07-.55-.35-.62-.24-.05-.57.07-.62.35,0,.05,0,.1,0,.15-.05,0-.11,0-.16.01-.28.09-.4.34-.35.62.1.51.24,1.02.43,1.51.21.53.46,1.13,1.12,1.16.36.02.66-.2.79-.52.09-.24.06-.53,0-.77Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M110.78,32.97c-.04-.23-.17-.44-.31-.62-.05-.06-.09-.12-.14-.18-.01-.02-.03-.04-.04-.06.04.06,0-.01-.01-.02-.06-.09-.13-.18-.18-.28-.06-.11-.12-.22-.17-.33,0,0,0,0,0,0-.01-.03-.02-.06-.03-.09-.02-.05-.03-.11-.05-.17,0-.02,0-.05-.01-.07,0,0,0,0,0,0,0,0,0,0,0,0,0-.06,0-.11,0-.17,0-.02,0-.05,0-.07,0,0,0-.02,0-.03.02-.06.04-.12.06-.19.1-.24-.11-.56-.35-.62-.29-.07-.51.09-.61.35-.07.18-.1.38-.1.57-.22.1-.37.34-.3.59.15.51.31,1.01.46,1.52.07.23.12.51.26.71.19.27.49.41.82.34.54-.11.82-.67.72-1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M119.59,26.25c-.18-.79-.55-1.51-1.06-2.13-.14-.17-.43-.18-.61-.08-.01,0-.02.02-.03.03-.1,0-.19,0-.27.06-.25.14-.3.44-.18.68.26.51-.15,1.25-.29,1.81-.18.76-.06,1.6.65,2.05.6.38,1.39.13,1.7-.5.29-.6.23-1.29.09-1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M129.65,25.97c-.09-.29-.19-.58-.3-.86-.13-.34-.28-.68-.45-1.01,0-.02,0-.04,0-.06,0-.18-.11-.34-.26-.43-.07-.14-.14-.28-.22-.41-.33-.55-1.19-.05-.86.5.12.21.24.42.35.64.02.55.04,1.1.06,1.66.02.56-.09,1.39.48,1.73.27.16.61.13.88-.03.3-.18.45-.49.48-.83.03-.31-.07-.62-.16-.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M143.18,30.2c-.09-.25-.34-.42-.62-.35-.21.06-.38.29-.36.51-.14-.01-.29.03-.39.14-.47.51-.4,1.19-.12,1.77.11.25.28.46.43.69.08.12.15.24.21.36,0,0,0,0,0,0,0,0,0,0,0,.02.01.03.02.06.03.1,0,.03.02.06.02.1,0,0,0,.02,0,.05.01.25.18.46.43.49.23.03.5-.11.55-.36.26-1.16.2-2.39-.2-3.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M147.01,37.94c-.08-.26-.35-.42-.62-.35-.23.06-.39.31-.35.55-.18.08-.3.25-.31.46-.02.67-.02,1.34.01,2.01.02.36.01.75.27,1.04.26.28.69.36,1.01.13.31-.22.32-.61.34-.96.02-.31.03-.63,0-.94-.04-.66-.16-1.31-.37-1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M109.97,40.78c-.64,0-.64,1,0,1s.64-1,0-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M119.37,45.08c-.06-.25-.22-.45-.42-.59-.16-.11-.37-.18-.56-.17,0,0-.01,0-.02,0-.13-.02-.27-.02-.4.01-.03,0-.05.03-.08.04-.03,0-.06-.02-.09-.02-.34,0-.49.27-.48.54-.2.38-.15.88.16,1.19.11.11.25.18.39.23.05.05.09.12.15.16.12.08.26.12.41.12.2,0,.38-.08.52-.21.18-.15.29-.38.37-.6.09-.23.1-.48.05-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M128.92,48c-.18-.23-.41-.39-.68-.48-.12-.04-.28-.01-.39.05-.1.06-.2.18-.23.3-.02.09-.01.18.01.27-.14.12-.21.31-.16.51.06.25.15.5.33.68.11.11.26.2.41.23.15.04.31.04.46,0,.11-.04.2-.09.29-.17.06-.05.11-.12.14-.19.07-.14.11-.3.1-.46-.02-.27-.12-.51-.28-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M136.61,46.06c-.64,0-.64,1,0,1s.64-1,0-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M143.96,40.78c-.09-.32-.32-.57-.64-.67-.14-.05-.33-.05-.47,0-.14.05-.28.13-.38.25-.14.16-.21.34-.23.55-.01.13.03.24.08.35,0,0,0,.02,0,.03.02.07.06.13.1.18,0,.14,0,.28.05.42.05.15.14.26.29.32.16.07.3.04.45-.03.52-.24.93-.82.76-1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M140.35,26.06c-.64,0-.64,1,0,1s.64-1,0-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M133.03,22.84c-.13-.19-.29-.32-.51-.41-.21-.08-.45-.05-.64.05-.15.08-.28.21-.35.36-.04.09-.08.19-.1.29,0,.03,0,.07,0,.1-.02.17,0,.35.07.51,0,.06,0,.12.02.17.03.19.12.36.25.51.14.16.36.27.58.27.26,0,.49-.14.63-.35.08-.12.12-.27.15-.41.04-.17.07-.35.07-.53,0-.2-.05-.41-.16-.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M123.18,22.29c-.19-.32-.56-.51-.93-.5-.14,0-.28.04-.41.1-.02,0-.03,0-.05,0-.25.05-.46.26-.53.5-.02.07-.03.15-.02.22,0,.03-.02.06-.02.1-.01.09,0,.19.03.29.06.22.2.4.39.52.12.08.26.11.4.11.2.09.42.13.63.05.21-.07.37-.2.49-.39.19-.29.2-.71.02-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M113.02,26.06c.01-.12,0-.23-.03-.35,0-.04-.01-.08-.02-.11-.02-.08-.05-.12-.09-.18-.01-.02-.03-.03-.04-.05-.05-.05-.1-.08-.16-.1-.04-.02-.08-.03-.12-.05,0,0-.01,0-.02,0,0,0-.01-.01-.02-.02-.05-.03-.12-.06-.18-.08-.07-.02-.14-.03-.22-.03-.15,0-.27.04-.4.1-.09.04-.17.11-.24.18-.1.11-.16.22-.22.36-.01.03-.02.05-.03.08-.01.07-.03.15-.03.22,0,.24.11.5.3.66.12.1.22.16.37.21.03.01.06.02.09.02.07.01.15.03.22.02.14-.01.28-.04.4-.12.12-.08.21-.17.29-.29.02-.02.03-.05.04-.07.03-.06.06-.13.08-.2,0-.03,0-.07,0-.1,0-.04.01-.07.02-.11Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBite);
export default __webpack_public_path__ + "static/media/bite.47b5da17f9b17d9e5b8882bcc2de102c.svg";
export { ForwardRef as ReactComponent };